// @flow

import { Config } from './config'
import ReactGA from 'react-ga'

/**
 * @summary Analytics
 * @description Wrapper for `react-ga`
 * @see {@link https://github.com/react-ga/react-ga}
 * @module src/util/tracker
 */

/** Initialize Analytics */
export const init = () => {
  ReactGA.initialize(Config.GA_ID, {
    debug: false,
    titleCase: false
  })
}

/** Send Google Analytics Event
 * @see {@link https://www.npmjs.com/package/react-ga#reactgaeventargs}
 */

type Args = {
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction?: Boolean,
  transport?: string
}

export const sendGaEvent = (args: Args) => {
  ReactGA.event(args)
}

export default ReactGA
